function locationStepBody(data) {
  const body = {};
  body.address = data.addressVal;

  const [latitude, longitude] = data.coordinates.split(',');
  body.coordinates = [parseFloat(longitude), parseFloat(latitude)];
  body.geolocation_visibility = data.visibility || 'EXACT';
  if (data.cep) {
    body.postal_code = data.cep;
  }
  if (data.postalCode) {
    body.postal_code = data.postalCode;
  }

  if (data.addressComplement || data.addressComplement === '') {
    body.addressComplement = data.addressComplement;
  }

  if (data.subDistrictVal) {
    body.location_id = data.subDistrictVal;
  } else if (data.districtVal) {
    body.location_id = data.districtVal;
  } else {
    body.location_id = data.cityVal;
  }

  return body;
}

export { locationStepBody };
